import { el } from '../../core/dom.js';
import {
  PLATFORM_GROUPS, STORE_CATEGORIES, stageRadios, togglePlatform, writeDraft,
} from './model.js';

/**
 * Step 1 — product details form (name, stage, intro, industry, platforms).
 * @param {object} state
 * @param {{ onContinue: () => void, onDraft: () => void, onChange: () => void }} handlers
 */
export function renderDetails(state, handlers) {
  const stages = stageRadios(state.stage);
  const selected = new Set(state.platforms || []);
  const count = selected.size;

  return el('form', {
    class: 'np-form np-glass rv np-rv-2',
    onSubmit(event) {
      event.preventDefault();
      handlers.onContinue();
    },
  },
  el('div', { class: 'np-grid' },
    el('div', { class: 'np-field np-grow' },
      el('label', { class: 'np-lbl', for: 'np-name' }, 'Product name'),
      el('input', {
        id: 'np-name',
        class: 'np-fld',
        type: 'text',
        required: true,
        placeholder: 'Enter your product name',
        value: state.name || '',
        onInput(event) {
          state.name = event.currentTarget.value;
          writeDraft(state);
          handlers.onChange();
        },
      })),
    el('fieldset', { class: 'np-field' },
      el('legend', { class: 'np-lbl' }, 'Stage'),
      el('div', { class: 'np-stages', role: 'group', 'aria-label': 'Stage' },
        stages.map((item) => el('button', {
          type: 'button',
          class: item.on ? 'np-chip is-on' : 'np-chip',
          'aria-pressed': item.on ? 'true' : 'false',
          'data-stage': item.id,
          onClick(event) {
            state.stage = item.id;
            writeDraft(state);
            // Update the chips in place: a full repaint replays the entrance animation.
            const group = event.currentTarget.parentElement;
            group.querySelectorAll('[data-stage]').forEach((chip) => {
              const on = chip.dataset.stage === item.id;
              chip.className = on ? 'np-chip is-on' : 'np-chip';
              chip.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            handlers.onChange();
          },
        }, item.label))))),
  el('div', { class: 'np-field' },
    el('label', { class: 'np-lbl', for: 'np-intro' }, 'Short intro — one line'),
    el('input', {
      id: 'np-intro',
      class: 'np-fld',
      type: 'text',
      placeholder: 'Describe your product in one line',
      value: state.intro || '',
      onInput(event) {
        state.intro = event.currentTarget.value;
        writeDraft(state);
        handlers.onChange();
      },
    })),
  el('div', { class: 'np-field' },
    el('label', { class: 'np-lbl', for: 'np-industry' }, 'Industry'),
    el('select', {
      id: 'np-industry',
      class: 'np-fld',
      onChange(event) {
        state.storeCategory = event.currentTarget.value;
        writeDraft(state);
        handlers.onChange();
      },
    },
    el('option', { value: '' }, 'Choose a category'),
    STORE_CATEGORIES.map((item) => el('option', {
      value: item.id,
      selected: state.storeCategory === item.id ? true : null,
    }, item.label)))),
  el('fieldset', { class: 'np-plats' },
    el('legend', { class: 'np-lbl' },
      'Platforms ',
      el('span', { class: 'np-sel', id: 'np-plat-count' }, `${count} selected`)),
    PLATFORM_GROUPS.map((group) => el('div', { class: 'np-plat-row' },
      el('span', { class: 'np-plat-label' }, group.label),
      el('div', { class: 'np-chips' },
        group.items.map((plat) => {
          const on = selected.has(plat.id);
          return el('button', {
            type: 'button',
            class: on ? 'np-chip is-pick' : 'np-chip',
            'aria-pressed': on ? 'true' : 'false',
            onClick(event) {
              state.platforms = togglePlatform(state.platforms, plat.id);
              writeDraft(state);
              const picked = (state.platforms || []).includes(plat.id);
              const chip = event.currentTarget;
              chip.className = picked ? 'np-chip is-pick' : 'np-chip';
              chip.setAttribute('aria-pressed', picked ? 'true' : 'false');
              chip.textContent = picked ? `✓ ${plat.label}` : plat.label;
              const counter = chip.closest('form').querySelector('#np-plat-count');
              if (counter) counter.textContent = `${(state.platforms || []).length} selected`;
              handlers.onChange();
            },
          }, on ? `✓ ${plat.label}` : plat.label);
        }))))),
  el('p', { id: 'np-error', class: 'np-error', role: 'alert', hidden: true }),
  el('div', { class: 'np-actions' },
    el('button', { type: 'submit', class: 'np-cta' }, 'Continue to Context ', el('span', { class: 'arw', 'aria-hidden': 'true' }, '→')),
    el('button', {
      type: 'button',
      class: 'np-btn',
      onClick: handlers.onDraft,
    }, 'Save Draft')));
}
